import graphql from 'babel-plugin-relay/macro';
import {FormikHelpers} from 'formik';
import React from 'react';
import {useMutation} from 'react-relay/hooks';
import {useHistory} from 'react-router';
import ConnectionHandler from 'relay-connection-handler-plus';
import {showEventNotification} from 'src/utils/notifications';

import Form from '../components/Form';
import {FormValues} from '../types';
import {createPageCreateValveConnectorMutation} from './__generated__/createPageCreateValveConnectorMutation.graphql';

function CreatePage() {
  const history = useHistory();

  const [commit, isInFlight] = useMutation<createPageCreateValveConnectorMutation>(
    createValveConnectorMutation,
  );

  return (
    <Form
      title="Create Valve Connection"
      button="Create Valve Connection"
      onSubmit={handleSubmit}
      isSubmitting={isInFlight}
    />
  );

  function handleSubmit(input: FormValues, formikHelpers: FormikHelpers<FormValues>) {
    commit({
      variables: {input},
      onCompleted: payload => {
        if (
          payload.createValveConnector?.errors[0] &&
          payload.createValveConnector?.errors[0].fields
        ) {
          payload.createValveConnector?.errors[0].fields.forEach(fieldError => {
            formikHelpers.setFieldError(fieldError.fieldName, fieldError.message);
          });
        }

        const entry = payload.createValveConnector?.valveConnector;

        if (entry) {
          showEventNotification('added', 'Connector', entry.name);
          return history.push('/admin/valve_connection_types');
        }
      },
      updater: store => {
        const root = store.getRoot();

        const connectionRecords = ConnectionHandler.getConnections(
          root,
          'ValveConnectorsList_valveConnectors',
        );

        if (!connectionRecords) {
          return;
        }

        const payload = store.getRootField('createValveConnector');

        if (!payload) {
          return;
        }

        const newRecord = payload.getLinkedRecord('valveConnector');

        if (!newRecord) {
          return;
        }

        connectionRecords.forEach(connectionRecord => {
          const newEdge = ConnectionHandler.createEdge(
            store,
            connectionRecord,
            newRecord,
            'valveConnectorEdge',
          );

          ConnectionHandler.insertEdgeAfter(connectionRecord, newEdge);
        });
      },
    });
  }
}

const createValveConnectorMutation = graphql`
  mutation createPageCreateValveConnectorMutation($input: CreateValveConnectorInput!) {
    createValveConnector(input: $input) {
      valveConnector {
        id
        createdAt
        name
      }
      errors {
        code
        fields {
          fieldName
          message
        }
      }
    }
  }
`;

export default CreatePage;
